export default {
  // server: 'http://208.68.38.138:1337'
  // server: 'http://localhost:1337'
  server: "https://linea2000api.ar",
};
